module.exports = __webpack_public_path__ + "components/flag/static/square/bz-735defa6cc5ea34f24e188ac6e0abee3.svg";